'use es6';

import hubapiStack from 'hub-http/stacks/hubapi';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import { safeMode } from 'hub-http/middlewares/core';
export const apiClient = promiseClient(createStack(safeMode, hubapiStack));